import { KioskDistributionApi } from 'api/KioskDistributionApi';
import { backendApiClient } from 'container/backendApiClient';

export const kioskDistributionApi = new KioskDistributionApi(backendApiClient);
